<!-- eslint-disable vuejs-accessibility/mouse-events-have-key-events -->
<template>
  <div class="installation-guide-token-view container">
    <Breadcrumbs class-name="py-0" />
    <div
      v-show="getSolicitation.cdSolicitacao !== ''"
      class="alert alert-dismissible alert-success"
      role="alert"
    >
      <div class="alert__icon">
        <Icon name="shield"></Icon>
      </div>
      <div class="alert__content">
        Parabéns! Sua solicitação foi enviada com sucesso! Verifique seu e-mail.
      </div>
      <button
        class="btn-close align-items-center"
        type="button"
        data-bs-dismiss="alert"
        aria-label="Fechar"
      >
        <Icon name="xmark"></Icon>
      </button>
    </div>
    <h1 class="text-start">
      Guia de instalação do Certificado Digital em mídia
    </h1>
    <h4 class="text-start only-desk">
      Veja como instalar seu Certificado Digital
    </h4>
    <h4 class="text-start only-mob">
      Agora vamos instalar seu Certificado Digital!
    </h4>
    <div
      class="container installation-guide-container d-flex flex-row py-3 mb-5"
    >
      <div class="img-logo-java">
        <img src="@/assets/images/java-logo.svg" alt="logo do java" />
      </div>
      <div class="description-to-install-java ms-3">
        <p>
          Antes de fazer o download do driver e do emissor, você precisa ter o
          Java instalado e atualizado em seu computador.
        </p>
        <p class="d-flex-flex-row text-start only-desk">
          <a
            class="text-start"
            href="https://www.java.com/pt-BR/download/"
            target="_blank"
          >
            <span>Clique aqui para fazer o download </span>
            <Icon class="ms-2" name="download"></Icon>
          </a>
        </p>
        <p class="d-flex-flex-row text-start only-mob">
          <a
            class="text-start"
            type="button"
            data-bs-target="#modal-only-desktop"
            data-bs-toggle="modal"
            >Clique aqui para fazer o download
            <Icon class="ms-2" name="download"></Icon
          ></a>
        </p>
      </div>
    </div>
    <h4 class="text-start mb-5">
      Escolha abaixo qual o tipo de Certificado você deseja instalar
    </h4>
    <div class="token-guides d-flex flex-row only-desk">
      <div class="token-guides__title d-flex flex-row">
        <span class="only-desk">Certificados Tipo A3</span>
        <div class="divider-token-large mx-4"></div>
      </div>
    </div>
    <div class="card-guides row gap-4">
      <div class="only-mob text-start d-flex flex-row">
        <span class="span-mob text-start">Certificados Tipo A3</span>
        <div class="divider-mob"></div>
      </div>
      <div class="col card">
        <div
          class="img-box-desktop my-3"
          @mouseover="hoverTokenA3 = true"
          @mouseout="hoverTokenA3 = false"
        >
          <img
            :src="tokenA3Anima"
            alt="Ilustração de um Token A3"
            @mouseover="hoverTokenA3 = true"
            @mouseout="hoverTokenA3 = false"
          />
        </div>
        <p class="fw-bold">A3 com Token</p>
        <a
          class="btn btn-outline-primary"
          type="button"
          href="/ManualEmissaoA3.pdf"
          target="_blank"
        >
          <Icon class="me-2" name="up-right-from-square"></Icon
          ><span>Abrir guia de instalação</span></a
        >
        <ModalTokenA3 />
        <ModalOnlyUseOnDesktop>
          <template #message>
            <h3>
              A instalação de um Certificado Digital através de Token ou
              Smartcard, deve ser feita em um
              <strong>computador ou notebook.</strong>
            </h3>
          </template>
        </ModalOnlyUseOnDesktop>
      </div>
      <div class="col card">
        <div
          class="img-box-desktop my-3"
          @mouseover="hoverSmartCard = true"
          @mouseout="hoverSmartCard = false"
        >
          <img
            class="mt-4"
            :src="smartcardAnima"
            alt=""
            @mouseover="hoverSmartCard = true"
            @mouseout="hoverSmartCard = false"
          />
        </div>
        <p class="fw-bold">A3 com Smartcard</p>
        <a
          class="btn btn-outline-primary"
          type="button"
          href="/ManualEmissaoA3.pdf"
          target="_blank"
        >
          <Icon class="me-2" name="up-right-from-square"></Icon
          ><span>Abrir guia de instalação</span></a
        >
        <ModalSmartCard></ModalSmartCard>
        <ModalOnlyUseOnDesktop>
          <template #message>
            <h3>
              A instalação de um Certificado Digital através de Token ou
              Smartcard, deve ser feita em um
              <strong>computador ou notebook.</strong>
            </h3>
          </template>
        </ModalOnlyUseOnDesktop>
      </div>
    </div>
    <Contact></Contact>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import Breadcrumbs from '@/components/Molecules/Breadcrumbs.vue'
  import ModalTokenA3 from '@/components/templates/ModalTokenA3.vue'
  import ModalSmartCard from '@/components/templates/ModalSmartCard.vue'
  import ModalOnlyUseOnDesktop from '@/components/templates/ModalOnlyUseOnDesktop.vue'
  import { mapState } from 'pinia'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'

  import smartcardImg from '@/assets/images/Smartcard.svg'
  import smartcardAnimationImg from '@/assets/images/smartcard.gif'
  import tokenA3Img from '@/assets/images/tokenA3.svg'
  import tokenA3AnimationImg from '@/assets/images/tokena3.gif'
  import desktopImg from '@/assets/images/desktop.svg'
  import desktopAnimationImg from '@/assets/images/desktop.gif'

  export default defineComponent({
    name: 'InstallationGuideBirdIdView',
    components: {
      Icon,
      Contact,
      Breadcrumbs,
      ModalTokenA3,
      ModalOnlyUseOnDesktop,
      ModalSmartCard,
    },
    data: () => ({
      smartcard: smartcardImg,
      smartcardAnimation: smartcardAnimationImg,
      hoverSmartCard: false,
      tokenA3: tokenA3Img,
      tokenA3Animation: tokenA3AnimationImg,
      hoverTokenA3: false,
      desktop: desktopImg,
      desktopAnimation: desktopAnimationImg,
      hoverDesktop: false,
    }),
    computed: {
      ...mapState(useSolicitation, ['getSolicitation']),
      smartcardAnima() {
        if (this.hoverSmartCard === true) {
          return this.smartcardAnimation
        }
        return this.smartcard
      },
      tokenA3Anima() {
        if (this.hoverTokenA3 === true) {
          return this.tokenA3Animation
        }
        return this.tokenA3
      },
      desktopAnima() {
        if (this.hoverDesktop === true) {
          return this.desktopAnimation
        }
        return this.desktop
      },
    },
  })
</script>

<style lang="stylus" scoped>
  @import './style.modules.styl'
</style>
